import format from "date-fns/format";
import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import { TbTicket } from "react-icons/tb";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../store";
interface IProps {
  ticket: Ticket;
  handleSetOpen: () => void;
  handleSetOpenChangeDate: () => void;
}

const TicketExercise: React.FC<IProps> = ({ ticket, handleSetOpenChangeDate, handleSetOpen }: IProps) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const allowToChangeDate = useSelector((state: State) => state.config.configuration.allowReservedExerciseChange);

  return (
    <React.Fragment>
      <div className="future-ticket flex-between-center">
        <div className="future-ticket-text flex-start-center">
          <div className="future-ticket-mini-calendar flex-center-center flex-wrap">
            <b>
              {format(ticket.exercises[0].startTime, "MMM", {
                locale: locale,
              })}
            </b>
            <b>
              {format(ticket.exercises[0].startTime, "d", {
                locale: locale,
              })}
            </b>
          </div>

          <div className="future-ticket-text-details">
            <h3>{ticket.exercises[0].name}</h3>

            <span>
              {format(ticket.exercises[0].startTime, "cccc", {
                locale: locale,
              })}{" "}
              / {t("godz")}: {format(ticket.exercises[0].startTime, "HH:mm")}
            </span>
            <div className=" ticket-name flex-start-center">
              <TbTicket className="icon" /> <b>{ticket.name}</b>
            </div>
          </div>
        </div>

        <div className="future-ticket-buttons-line">


          {ticket.name !== "REZERWACJA" &&
            <React.Fragment>
              {allowToChangeDate && <button
                onClick={() => handleSetOpenChangeDate()}
                className="button medium padding-medium button-fill-background-main full-button"
              >
                {t("zmien_termin")}
              </button>}
            </React.Fragment>}

          <button onClick={() => handleSetOpen()} className="button medium padding-medium button-fill-main full-button">
            {t("pokaz_kod_qr")}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketExercise;
